module.exports = __webpack_public_path__ + "static/semantic-card-group-5d5e64857d8966b2d626d8ecdda20c66.png";